module.exports = __webpack_public_path__ + "e10d5f544d7893a418e51f591e6654f0.MP3";